<template>
  <div class="announcements">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="classNoticeboard"
      class="layout"
    >
      <br>
      <ListOfClassAnnouncements
        :announcements="classNoticeboard"
        @announcementdeletion="announceDeletion"
        />
    </div>
    <div
      v-else
      class="card"
    >
      <p>No announcements at the moment, check back later</p>
      <Spinner />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'
import ListOfClassAnnouncements from '@/components/ListOfClassAnnouncements.vue'
import Spinner from '@/components/Spinner.vue'
import { ref, watchEffect } from '@vue/runtime-core'

export default {
  name: 'Home',
  props: ['classNotice'],
  components: { ListOfClassAnnouncements, Spinner },
  setup (props, context) {
    const classNoticeboard = ref(null)
    const { myData, error, load } = getPosts()

    const announceDeletion = () => {
      context.emit('announcementdeleted')
    }

    load(props.classNotice.grade + '/classannouncements/teacher')

    watchEffect(() => {
      classNoticeboard.value = myData.value ? myData.value : null
    })
    return { classNoticeboard, error, announceDeletion }
  }
}
</script>

<style>
  .announcements {
    max-width: 960px;
    margin: 0 auto;
    padding: 10px;
    background: #fff;
    color: var(--inspire-charcoal);
  }
</style>
